import { PortalAdminPages, PortalAdminAdvancedPortalDataPageName } from '@pages/PortalAdmin/PortalAdmin.constants';

export const treeItems = [
  {
    url: PortalAdminPages[PortalAdminAdvancedPortalDataPageName.BrokerageCommission].url,
    label: 'Brokerage Commissions Defaults',
  },
  {
    url: PortalAdminPages[PortalAdminAdvancedPortalDataPageName.BusinessClasses].url,
    label: 'Business Classes',
  },
  {
    url: PortalAdminPages[PortalAdminAdvancedPortalDataPageName.Coverages].url,
    label: 'Coverages',
  },
  {
    url: PortalAdminPages[PortalAdminAdvancedPortalDataPageName.LegalNoticeManagement].url,
    label: 'Legal Notice Management',
  },
  {
    url: PortalAdminPages[PortalAdminAdvancedPortalDataPageName.LOIAvailability].url,
    label: 'Line of Insurance Availability',
  },
  {
    url: PortalAdminPages[PortalAdminAdvancedPortalDataPageName.OfferingDefaultJurisdiction].url,
    label: 'Offering Default Jurisdictions',
  },
  {
    url: PortalAdminPages[PortalAdminAdvancedPortalDataPageName.PostRateDefaultFactors].url,
    label: 'Post Rate Default Factors',
  },
  {
    url: PortalAdminPages[PortalAdminAdvancedPortalDataPageName.OfferingSubjectivities].url,
    label: 'Subjectivities',
  },
  {
    url: PortalAdminPages[PortalAdminAdvancedPortalDataPageName.UnderwritingActivityTypes].url,
    label: 'Underwriting Activity Types',
  },
];
